import { Box, styled } from '@mui/material';

export const AddNoteIconWrapper = styled(Box)({
  color: '#0675DD',
  width: '22px',
  height: '22px',
  marginRight: '15px',
  cursor: 'pointer'
});

export const NoteWrapper = styled(Box)({
  margin: '5px 10px 15px 0'
});

export const NoteText = styled(Box)({
  fontSize: '14px'
});

export const NoteSignature = styled(Box)({
  fontSize: '10px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'end',
  marginTop: '5px',
  alignItems: 'center'
});
